
import React from 'react';
import {FaFolder, FaFolderOpen} from "react-icons/fa";


function Breadcrumb(props) {

    
            return (
             
              <li
              key={props.name }
              className=""
            >
               
                <a disabled={props.disabled} data-itemtype="Folder" title={props.title} href={props.href} >{props.isSeperator ? '' : !props.disabled ? <FaFolder /> : <FaFolderOpen />} {props.name }</a> 
 
                 
 
              </li>
            )};

export default Breadcrumb; 